import { useEffect, useState } from 'react';
import workspaceAPI from '../../services/workspaceAPI';

const WorkspaceActivity = () => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [skip, setSkip] = useState(0);
  const [error, setError] = useState('');
  const limit = 50;

  const load = (offset = 0) => {
    workspaceAPI
      .getActivity({ limit, skip: offset })
      .then((res) => {
        setItems(res.data.items || []);
        setTotal(res.data.total || 0);
        setSkip(offset);
      })
      .catch((err) => setError(err.response?.data?.message || 'Failed to load activity'));
  };

  useEffect(() => { load(0); }, []);

  if (error) return <p className="workspace-alert error">{error}</p>;

  return (
    <div>
      <h1 className="workspace-page-title">Activity monitoring & logs</h1>
      <p className="workspace-page-subtitle">{total} audit log entries for your company workspace.</p>
      <div className="workspace-table-wrap">
        <table className="workspace-table">
          <thead>
            <tr>
              <th>Action</th>
              <th>Summary</th>
              <th>Actor</th>
              <th>When</th>
            </tr>
          </thead>
          <tbody>
            {items.map((row) => (
              <tr key={row._id}>
                <td><span className="workspace-badge">{row.action}</span></td>
                <td>{row.summary}</td>
                <td>{row.actorName || '—'}</td>
                <td>{new Date(row.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="workspace-btn-row" style={{ marginTop: 16 }}>
        <button type="button" className="workspace-btn secondary" disabled={skip <= 0} onClick={() => load(Math.max(0, skip - limit))}>Previous</button>
        <button type="button" className="workspace-btn secondary" disabled={skip + limit >= total} onClick={() => load(skip + limit)}>Next</button>
      </div>
    </div>
  );
};

export default WorkspaceActivity;
